import React from 'react';

import {CloseIconGray, SearchFrogGreen} from '../../styles/icons';

const SearchField = ({
    children,
    text = '',
    inputId = '',
    inputType = '',
    inputName = '',
    maxLength = 524288, // HTML default maxlength val
    inputPlaceholder = '',
    customSearchClass = '',
    boxClass = 'border rounded',
    autoComplete = 'off',
    onChange = () => {},
    onFocus = () => {},
    onBlur = () => {},
    onClickSearch = () => {},
    onKeyDown = (ev) => {
        if (ev.key === 'Enter' || ev.keyCode === 13) {
            onClickSearch();
            if (inputId !== '') {
                document.getElementById(inputId).blur();
            }
        }
    },
    isDisabled = false,
    showCancel = true,
    onClickCancel = () => {},
    showSearch = true,
    spellCheck = false
}) => {
    return (
        <form className={`${customSearchClass || 'search-field'}`} action='' onSubmit={onClickSearch}>
            <input
                type={inputType || 'text'}
                className={boxClass}
                id={inputId}
                value={text}
                name={inputName}
                spellCheck={spellCheck}
                maxLength={maxLength}
                placeholder={inputPlaceholder}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                onKeyDown={onKeyDown}
                disabled={isDisabled}
                autoComplete={autoComplete}
            />
            {showCancel && text && (
                <span className='position-absolute close-icon cursor-pointer' onClick={onClickCancel}>
                    <CloseIconGray />
                </span>
            )}
            {showSearch && (
                <span className='position-absolute glass-icon cursor-pointer' onClick={onClickSearch}>
                    <SearchFrogGreen />
                </span>
            )}
            {children}
        </form>
    );
};
export default SearchField;
